import { render, staticRenderFns } from "./pautaanual24_2020.vue?vue&type=template&id=6028b1a8&"
import script from "./pautaanual24_2020.vue?vue&type=script&lang=js&"
export * from "./pautaanual24_2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports